import { connect } from "react-redux";
import { Dispatch } from "redux";
import { assignPageSelectors } from "../../../pages/assign";
import { assignPageActions } from "../../../pages/assign";
import { employeesSelector } from "../../../store/employees.store";
import { groupsSelector } from "../../../store/groups.store";
import { RootState } from "../../../store/index.store";
import { dialogPropsSelector, uiActions } from "../../../store/ui.store";
import {
  CustomFilterRegistrationDialog as CustomFilterRegistrationDialogComponent,
  customFilterRegistrationFormId
} from "./CustomFilterRegistrationDialog";

const mapStateToProps = (state: RootState) => ({
  dialogProps: dialogPropsSelector(state),
  initialValues: assignPageSelectors.getSelectedJob(state),
  groups: groupsSelector(state),
  employees: employeesSelector(state)
});

const mapStateToDispatch = (dispatch: Dispatch) => ({
  close: () =>
    dispatch(
      uiActions.SYSTEM_CLOSE_DIALOG({ formId: customFilterRegistrationFormId })
    ),
  submit: (values: any) =>
    dispatch(
      assignPageActions.USER_CLICKED_SUBMIT_CUSTOM_FILTER_BUTTON({
        filterName: values.filterName,
        defaultGroupingKey: values.groupingCondition,
        defaultGroupingExpansionState: values.defaultGroupingExpansionState
      })
    )
});

export const CustomFilterRegistrationDialog = connect(
  mapStateToProps,
  mapStateToDispatch
)(CustomFilterRegistrationDialogComponent);
